import { render, staticRenderFns } from "./PollMatrixResults.vue?vue&type=template&id=97a1b608&scoped=true"
import script from "./PollMatrixResults.vue?vue&type=script&lang=js"
export * from "./PollMatrixResults.vue?vue&type=script&lang=js"
import style0 from "./PollMatrixResults.vue?vue&type=style&index=0&id=97a1b608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a1b608",
  null
  
)

export default component.exports